const handle = () => new Promise<void>(() => {
  window.location.href = '/error/resetsession?reason=onepagegivingmaxattempts';
});

export default {
  handle,
};
